import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

export type KambiCouponBetStatus =
  | 'Won'
  | 'Pending'
  | 'No Payout'
  | 'Refunded'
  | 'Cashed Out'
  | null

export function getKambiCouponBetStatus(
  betStatus?:
    | KambiHistoryCoupon['bets'][0]['betStatus']
    | KambiHistoryCoupon['couponRows'][0]['status']
): KambiCouponBetStatus {
  if (!betStatus) return null

  switch (betStatus) {
    case 'WON':
    case 'CLAIMED':
      return 'Won'
    case 'CASHED_OUT':
    case 'CASHED_IN':
      return 'Cashed Out'
    case 'VOID':
    case 'CANCELLED':
    case 'DELETED':
      return 'Refunded'
    case 'LOST':
    case 'REJECTED':
    case 'REJECTED_BY_AAMS':
    case 'EXPIRED':
    case 'UNFUNDED':
    case 'REJECTED_LIVE':
    case 'REJECTED_PBA':
    case 'REJECTED_POOL_BET':
      return 'No Payout'
    case 'OPEN':
    case 'PLACED':
    case 'WAITING_FOR_APPROVAL':
    case 'WAITING_FOR_APPROVAL_BY_AAMS':
    default:
      return 'Pending'
  }
}
